export default __webpack_public_path__ + "static/media/icon-more-dark.0ec43ba4.svg";